import Aegis from "@tencent/aegis-web-sdk"
import _ from "lodash"

// 屏蔽接口测试的黑名单
const speedBlackList = [
  // 上报接口
  "log_data",
  // 本地接口
  "localhost",
  // 图片接口
  ".*?(gif|jpeg|png|jpg|bmp)",
  // 上报接口
  "szmg.qq.com"
]

/**
 * 判断是否是生产环境
 * @returns {boolean}
 */
const isProduction = () => {
  return process.env.NODE_ENV === "production"
}

/**
 * 获取文件的后缀
 * @param url
 * @returns {string | *}
 */
const getRequestExt = url => {
  let request = url.split("?")[0]

  return request.substr(request.lastIndexOf(".") + 1)
}

/**
 * aegis 配置
 * @type {Aegis}
 */
export const aegis = new Aegis({
  id: "6381",

  // 开启接口测速
  reportApiSpeed: isProduction(),

  // 开启静态资源测速
  reportAssetSpeed: isProduction(),

  // 开启页面测速
  pagePerformance: isProduction(),

  // 当前实例是否需要进行错误监听，获取错误日志
  onError: true,

  // 当前页面是否是单页应用？true的话将会监听hashchange及history api
  spa: true,

  // 白名单确认接口
  whiteListUrl: "",

  beforeReport(log) {
    // 黑名单内的内容不上报
    let containBlack = _.some(speedBlackList, black => {
      return log.msg.indexOf(black) !== -1
    })

    if (containBlack) {
      return false
    }

    // 非生产环境屏蔽
    if (!isProduction()) {
      console.log("log", log)
      return false
    }
  },

  // 测速上报
  beforeReportSpeed(msg) {
    // 非生产环境不上报
    if (!isProduction()) {
      return false
    }

    // 黑名单内的内容不上报
    let containBlack = _.some(speedBlackList, black => {
      return !!new RegExp(black, "g").test(msg.url)
    })

    if (containBlack) {
      return false
    }

    return msg
  },

  // 接口错误回调上报
  api: {
    // 接口类型修正
    resourceTypeHandler(url) {
      if (url.indexOf("api.unipay.qq.com") !== -1) {
        return "fetch"
      }

      if (getRequestExt(url) === "json") {
        return "static"
      }
    },

    // 错误码上报处理
    retCodeHandler(data) {
      try {
        data = JSON.parse(data)
      } catch (e) {
        // console.log("e", e)
      }

      return {
        isErr: data && data.ret !== undefined && data.ret !== 0,
        code: data.ret
      }
    }
  }
})

export default {
  install(Vue) {
    Vue.$aegis = Vue.prototype.$aegis = aegis
  }
}
